import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useFeatureFlags } from '@/helper/FeatureFlags';
import { useFunctionalPermissions } from '@/helper/FunctionalPermissions';
import { useAppConfig } from '@/hooks/useAppConfig';
import useDefaultWidgetId from '@/modules/corporate/modules/discover/views/Discover/hooks/useDefaultWidgetId';

import { UnifiedNav } from '../../types';
import { buildUnifiedNav } from '../../utils';

interface UseUnifiedNavResult {
  nav: UnifiedNav;
  isLoading: boolean;
}

function useUnifiedNav(): UseUnifiedNavResult {
  const { t } = useTranslation(['Common', 'Admin']);
  const flags = useFeatureFlags();
  const { site, ui } = useAppConfig();
  const { defaultWidgetId } = useDefaultWidgetId();
  const { hasPermission, fetching } = useFunctionalPermissions();

  const communityId = site.defaultCommunitySettings?.communityId;
  const isQuestionBankDisabled = !!ui?.disableQuestionBank;

  const nav = useMemo(
    () =>
      buildUnifiedNav({
        t,
        flags,
        communityId,
        defaultWidgetId,
        isQuestionBankDisabled,
        hasPermission,
      }),
    [t, flags, communityId, defaultWidgetId, isQuestionBankDisabled, hasPermission],
  );

  return { nav, isLoading: fetching };
}

export default useUnifiedNav;
